export enum FindParam {
  KEY = "key",
  TEXT = "text"
}
